import api from "./../api";
import UtilsUrl from "../../utils/UtilsUrl";

class HomeService {
  getShopAndChiffreAffaireStatByUser(idUser) {
    return api.get(
      UtilsUrl.HomePosURL() + "/getShopAndChiffreAffaireStatByUser/" + idUser
    );
  }
  getShopAndChiffreAffaireStatBySociete(idSociete) {
    return api.get(
      UtilsUrl.HomePosURL() +
        "/getShopAndChiffreAffaireStatBySociete/" +
        idSociete
    );
  }
}
export default new HomeService();
